import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import plusIcon from './../../../../../Assets/icons/plus-circle.svg'
import MinusIcon from './../../../../../Assets/icons/Minus-circle.svg'
import './index.scss'
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import backicon from '../../../../../Assets/icons/backIcon.svg';

const PrivilegesComponent = () => {
  const [checkedState, setCheckedState] = useState({});
  const [accordionState, setAccordionState] = useState({});
  const [privilegesData, setPrivilegesData] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("authToken");
  const business_partner_id = localStorage.getItem("business_partner_id");
  const location = useLocation();
  const role_id=location?.state?.data?.role_id
  const navigate=useNavigate()
  const { data } = location.state || {};

  const toggleAccordion = (parentId) => {
    const newState = { ...accordionState };
    newState[parentId] = !newState[parentId];
    setAccordionState(newState);
  };

  useEffect(() => {
    // Initialize checkedState based on privilegesData
    const initialState = {};
    privilegesData.forEach((parentMenu) => {
      initialState[`${parentMenu.parentId}-parent`] =
        parentMenu.parentMenuIsActive;
      parentMenu.children.forEach((childMenu) => {
        initialState[`${parentMenu.parentId}-${childMenu.childId}-menu`] =
          childMenu.childMenuIsActive;
        initialState[`${parentMenu.parentId}-${childMenu.childId}-add`] =
          childMenu.childMenuAdd !== "0";
        initialState[`${parentMenu.parentId}-${childMenu.childId}-edit`] =
          childMenu.childMenuEdit !== "0";
        initialState[`${parentMenu.parentId}-${childMenu.childId}-view`] =
          childMenu.childMenuView !== "0";
        // Initialize subchild states
        if (childMenu.subchildren) {
          childMenu.subchildren.forEach((subchildMenu) => {
            initialState[`${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-menu`] =
              subchildMenu.subchildMenuIsActive;
            initialState[`${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-add`] =
              subchildMenu.subchildMenuAdd !== "0";
            initialState[`${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-edit`] =
              subchildMenu.subchildMenuEdit !== "0";
            initialState[`${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-view`] =
              subchildMenu.subchildMenuView !== "0";
          });
        }
      });
    });
    setCheckedState(initialState);
  }, [privilegesData]);

  const isAccordionExpanded = (parentId) => {
    return accordionState[parentId];
  };
  const handleParentCheckboxChange = (parentId) => {
    const newState = { ...checkedState };
    const isChecked = !newState[`${parentId}-parent`];
    newState[`${parentId}-parent`] = isChecked;
  
    privilegesData.forEach((parentMenu) => {
      if (parentMenu.parentId === parentId) {
        parentMenu.children.forEach((childMenu) => {

          newState[`${parentId}-${childMenu.childId}-menu`] = isChecked;
          newState[`${parentId}-${childMenu.childId}-add`] = isChecked;
          newState[`${parentId}-${childMenu.childId}-edit`] = isChecked;
          newState[`${parentId}-${childMenu.childId}-view`] = isChecked;
  
          if (childMenu.subchildren) {
            childMenu.subchildren.forEach((subchildMenu) => {
              newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-menu`] = isChecked;
              newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-add`] = isChecked;
              newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-edit`] = isChecked;
              newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-view`] = isChecked;
            });
          }
        });
      }
    });
  
    setCheckedState(newState);
  };
  const handleMenuCheckboxChange = (parentId, childId) => {
    const newState = { ...checkedState };
  
    // Toggle the child menu checkbox
    const isChildChecked = !newState[`${parentId}-${childId}-menu`];
    newState[`${parentId}-${childId}-menu`] = isChildChecked;
  
    // If the menu checkbox is checked, set add, edit, and view to true, otherwise false
    newState[`${parentId}-${childId}-add`] = isChildChecked;
    newState[`${parentId}-${childId}-edit`] = isChildChecked;
    newState[`${parentId}-${childId}-view`] = isChildChecked;
  
    // Loop through the parent menu to find the child menu and its subchildren
    privilegesData.forEach((parentMenu) => {
      if (parentMenu.parentId === parentId) {
        parentMenu.children.forEach((childMenu) => {
          if (childMenu.childId === childId && childMenu.subchildren) {
            // For each subchild, set its `menu`, `add`, `edit`, and `view` based on the parent child menu state
            childMenu.subchildren.forEach((subchildMenu) => {
              // Toggle the subchild menu checkbox
              newState[`${parentId}-${childId}-${subchildMenu.subchildId}-menu`] = isChildChecked;
  
              // Set add, edit, and view to match the child menu state
              newState[`${parentId}-${childId}-${subchildMenu.subchildId}-add`] = isChildChecked;
              newState[`${parentId}-${childId}-${subchildMenu.subchildId}-edit`] = isChildChecked;
              newState[`${parentId}-${childId}-${subchildMenu.subchildId}-view`] = isChildChecked;
            });
          }
        });
      }
    });
  
    // Update the state with the new checked/unchecked values
    setCheckedState(newState);
  };
  const handleCheckboxChange = (parentId, childId, subchildIdOrAction) => {
    const newState = { ...checkedState };
  console.log("======",parentId, childId, subchildIdOrAction);
  
    if (subchildIdOrAction.includes("menu")) {
      // If the subchild menu is being checked/unchecked
      const subchildId = subchildIdOrAction.split("-")[0]; // Extract subchildId from the input
      const isChecked = !newState[`${parentId}-${childId}-${subchildId}-menu`];
  
      // Toggle the subchild menu checkbox
      newState[`${parentId}-${childId}-${subchildId}-menu`] = isChecked;
  
      // Set add, edit, view based on the menu's state
      newState[`${parentId}-${childId}-${subchildId}-add`] = isChecked;
      newState[`${parentId}-${childId}-${subchildId}-edit`] = isChecked;
      newState[`${parentId}-${childId}-${subchildId}-view`] = isChecked;
    } else {
      // For individual actions like add/edit/view
      newState[`${parentId}-${childId}-${subchildIdOrAction}`] = !newState[`${parentId}-${childId}-${subchildIdOrAction}`];
  
      // Check if all three actions (add, edit, view) are unchecked
      const subchildId = subchildIdOrAction.split("-")[0]; // Extract subchildId for the current action
      const isAllUnchecked =
        !newState[`${parentId}-${childId}-${subchildId}-add`] &&
        !newState[`${parentId}-${childId}-${subchildId}-edit`] &&
        !newState[`${parentId}-${childId}-${subchildId}-view`];
  
      // If all actions are unchecked, also uncheck the subchild menu
      if (isAllUnchecked) {
        newState[`${parentId}-${childId}-${subchildId}-menu`] = false;

      }
      const isAllParentUnchecked =
      !newState[`${parentId}-${childId}-add`] &&
      !newState[`${parentId}-${childId}-edit`] &&
      !newState[`${parentId}-${childId}-view`];

    // If all actions are unchecked, also uncheck the subchild menu
    if (isAllParentUnchecked) {
      newState[`${parentId}-${childId}-menu`] = false;
    }
    }
  
    setCheckedState(newState);
  };
  
  // const handleCheckboxChange = (parentId, childId, subchildIdOrAction) => {
  //   const newState = { ...checkedState };
  
  //   if (subchildIdOrAction.includes("menu")) {
  //     // If the subchild menu is being checked/unchecked
  //     const subchildId = subchildIdOrAction.split("-")[0]; // Extract subchildId from the input
  //     const isChecked = !newState[`${parentId}-${childId}-${subchildId}-menu`];
      
  //     // Toggle the subchild menu checkbox
  //     newState[`${parentId}-${childId}-${subchildId}-menu`] = isChecked;
  
  //     // Set add, edit, view based on the menu's state
  //     newState[`${parentId}-${childId}-${subchildId}-add`] = isChecked;
  //     newState[`${parentId}-${childId}-${subchildId}-edit`] = isChecked;
  //     newState[`${parentId}-${childId}-${subchildId}-view`] = isChecked;
  //   } else {
  //     // For individual actions like add/edit/view
  //     newState[`${parentId}-${childId}-${subchildIdOrAction}`] = !newState[`${parentId}-${childId}-${subchildIdOrAction}`];
  //   }
  
  //   setCheckedState(newState);
  // };
  
  
  // const handleMenuCheckboxChange = (parentId, childId) => {
  //   const newState = { ...checkedState };
    
  //   // Toggle the child menu checkbox
  //   newState[`${parentId}-${childId}-menu`] = !newState[`${parentId}-${childId}-menu`];
    
  //   // If the menu checkbox is checked, set add, edit, and view to true, otherwise false
  //   newState[`${parentId}-${childId}-add`] = newState[`${parentId}-${childId}-menu`];
  //   newState[`${parentId}-${childId}-edit`] = newState[`${parentId}-${childId}-menu`];
  //   newState[`${parentId}-${childId}-view`] = newState[`${parentId}-${childId}-menu`];
  
  //   privilegesData.forEach((parentMenu) => {
  //     if (parentMenu.parentId === parentId) {
  //       parentMenu.children.forEach((childMenu) => {
  //         if (childMenu.childId === childId && childMenu.subchildren) {
  //           childMenu.subchildren.forEach((subchildMenu) => {
  //             console.log("subchildMenu>>>",subchildMenu);
              
  //             // Set the subchild menu and permissions to match the parent child menu state
  //             newState[`${parentId}-${childId}-${subchildMenu.subchildId}-menu`] =
  //               newState[`${parentId}-${childId}-menu`];
  //             newState[`${parentId}-${childId}-${subchildMenu.subchildId}-add`] =
  //               newState[`${parentId}-${childId}-menu`];
  //             newState[`${parentId}-${childId}-${subchildMenu.subchildId}-edit`] =
  //               newState[`${parentId}-${childId}-menu`];
  //             newState[`${parentId}-${childId}-${subchildMenu.subchildId}-view`] =
  //               newState[`${parentId}-${childId}-menu`];
  //           });
  //         }
  //       });
  //     }
  //   });
  
  //   setCheckedState(newState);
  // };
  

  // const handleParentCheckboxChange = (parentId) => {
  //   const newState = { ...checkedState };
  //   const isChecked = !newState[`${parentId}-parent`];
  //   newState[`${parentId}-parent`] = isChecked;

  //   privilegesData.forEach((parentMenu) => {
  //     if (parentMenu.parentId === parentId) {
  //       parentMenu.children.forEach((childMenu) => {
  //         newState[`${parentId}-${childMenu.childId}-menu`] = isChecked;
  //         newState[`${parentId}-${childMenu.childId}-add`] =
  //           isChecked && newState[`${parentId}-${childMenu.childId}-add`];
  //         newState[`${parentId}-${childMenu.childId}-edit`] =
  //           isChecked && newState[`${parentId}-${childMenu.childId}-edit`];
  //         newState[`${parentId}-${childMenu.childId}-view`] =
  //           isChecked && newState[`${parentId}-${childMenu.childId}-view`];
  //         if (childMenu.subchildren) {
  //           childMenu.subchildren.forEach((subchildMenu) => {
  //             newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-menu`] = isChecked;
  //             newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-add`] =
  //               isChecked && newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-add`];
  //             newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-edit`] =
  //               isChecked && newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-edit`];
  //             newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-view`] =
  //               isChecked && newState[`${parentId}-${childMenu.childId}-${subchildMenu.subchildId}-view`];
  //           });
  //         }
  //       });
  //     }
  //   });

  //   setCheckedState(newState);
  // };

  // const handleMenuCheckboxChange = (parentId, childId) => {
  //   const newState = { ...checkedState };
  //   newState[`${parentId}-${childId}-menu`] =
  //     !newState[`${parentId}-${childId}-menu`];
  //   newState[`${parentId}-${childId}-add`] =
  //     newState[`${parentId}-${childId}-menu`] &&
  //     newState[`${parentId}-${childId}-add`];
  //   newState[`${parentId}-${childId}-edit`] =
  //     newState[`${parentId}-${childId}-menu`] &&
  //     newState[`${parentId}-${childId}-edit`];
  //   newState[`${parentId}-${childId}-view`] =
  //     newState[`${parentId}-${childId}-menu`] &&
  //     newState[`${parentId}-${childId}-view`];

  //   privilegesData.forEach((parentMenu) => {
  //     if (parentMenu.parentId === parentId) {
  //       parentMenu.children.forEach((childMenu) => {
  //         if (childMenu.childId === childId && childMenu.subchildren) {
  //           childMenu.subchildren.forEach((subchildMenu) => {
  //             newState[`${parentId}-${childId}-${subchildMenu.subchildId}-menu`] =
  //               newState[`${parentId}-${childId}-menu`];
  //             newState[`${parentId}-${childId}-${subchildMenu.subchildId}-add`] =
  //               newState[`${parentId}-${childId}-menu`] &&
  //               newState[`${parentId}-${childId}-${subchildMenu.subchildId}-add`];
  //             newState[`${parentId}-${childId}-${subchildMenu.subchildId}-edit`] =
  //               newState[`${parentId}-${childId}-menu`] &&
  //               newState[`${parentId}-${childId}-${subchildMenu.subchildId}-edit`];
  //             newState[`${parentId}-${childId}-${subchildMenu.subchildId}-view`] =
  //               newState[`${parentId}-${childId}-menu`] &&
  //               newState[`${parentId}-${childId}-${subchildMenu.subchildId}-view`];
  //           });
  //         }
  //       });
  //     }
  //   });

  //   setCheckedState(newState);
  // };

  // const handleCheckboxChange = (parentId, childId, type, subchildId) => {
  //   const newState = { ...checkedState };
  //   const key = subchildId
  //     ? `${parentId}-${childId}-${subchildId}-${type}`
  //     : `${parentId}-${childId}-${type}`;
  //   newState[key] = !newState[key];
  //   setCheckedState(newState);
  // };

  const isParentChecked = (parentId) => {
    return checkedState[`${parentId}-parent`];
  };

  const isMenuChecked = (parentId, childId) => {
    return checkedState[`${parentId}-${childId}-menu`];
  };

  const isSubchildChecked = (parentId, childId, subchildId) => {
    return checkedState[`${parentId}-${childId}-${subchildId}-menu`];
  };

  const getPrivileges = useCallback(
    async (cardId) => {
      setIsLoading(true);
      try {
        if (!token) {
          throw new Error("Token not found");
        }

        const response = await axiosInstance.post(
          "/getmenuList",
          { business_partner_id: 1, role_id: role_id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status !== 200) {
          throw new Error("Failed to fetch privileges");
        }

        const data = response.data.data;
        setPrivilegesData(data);
      } catch (error) {
        setError(error.message);
        console.error("Error fetching privileges:", error.message);
      } finally {
        setIsLoading(false);
      }
    },
    [token]
  );

  useEffect(() => {
    getPrivileges();
  }, [getPrivileges]);

  const handleSubmit = () => {
    const selectedPrivileges = [];

    privilegesData.forEach((parentMenu) => {
      if (checkedState[`${parentMenu.parentId}-parent`]) {
        // Add parent menu with default values (0 0 0 0)
        selectedPrivileges.push(`${parentMenu.parentId}_0_0_0`);
      }
      parentMenu.children.forEach((childMenu) => {
        if (checkedState[`${parentMenu.parentId}-${childMenu.childId}-menu`]) {
          const add = checkedState[
            `${parentMenu.parentId}-${childMenu.childId}-add`
          ]
            ? 1
            : 0;
          const edit = checkedState[
            `${parentMenu.parentId}-${childMenu.childId}-edit`
          ]
            ? 2
            : 0;
          const view = checkedState[
            `${parentMenu.parentId}-${childMenu.childId}-view`
          ]
            ? 3
            : 0;
          const privilegeString = `${childMenu.childId}_${add}_${edit}_${view}`;
          selectedPrivileges.push(privilegeString);

          if (childMenu.subchildren) {
            childMenu.subchildren.forEach((subchildMenu) => {
              if (
                checkedState[
                  `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-menu`
                ]
              ) {
                const subAdd = checkedState[
                  `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-add`
                ]
                  ? 1
                  : 0;
                const subEdit = checkedState[
                  `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-edit`
                ]
                  ? 2
                  : 0;
                const subView = checkedState[
                  `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-view`
                ]
                  ? 3
                  : 0;
                const subPrivilegeString = `${subchildMenu.subchildId}_${subAdd}_${subEdit}_${subView}`;
                selectedPrivileges.push(subPrivilegeString);
              }
            });
          }
        }
      });
    });

    const payload = {
      
      menu_id_access: selectedPrivileges.join(","),
    };
    axiosInstance.patch(`/updateMenu/${role_id}`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    })
      .then(response => {
        navigate(ROUTES_NAVIGATION.ROLELIST)
        console.log('Response:', response.data);
      })
      .catch(error => {
        console.error('Error saving privileges:', error.message);
      });

    console.log(payload);
    console.log(selectedPrivileges);
    setCheckedState({});
  };

  return (
    <div>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">{data.role_name} </span>
      </div>
      {privilegesData.map((parentMenu) => (
     <div key={parentMenu.parentId} className="accordion-container mt-2 mb-3">
    <div
  onClick={() => toggleAccordion(parentMenu.parentId)}
  className="accordion-header"
>
  <img
    src={isAccordionExpanded(parentMenu.parentId) ? MinusIcon : plusIcon}
    alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
    className="accordion-icon"
  />
  {parentMenu.parentMenuName}
</div>
     {isAccordionExpanded(parentMenu.parentId) && (
       <div className="accordion-content">
         <label className="child-menus-checkbox">
           <input
             type="checkbox"
             checked={isParentChecked(parentMenu.parentId)}
             onChange={() => handleParentCheckboxChange(parentMenu.parentId)}
           />
           {parentMenu.parentMenuName}
         </label>
         {parentMenu.children.map((childMenu) => (
           <div key={childMenu.childId} className="child-menus mt-3 mb-3">
             <div className="child-item mt-2 mb-2">
               <label className="child-menus-checkbox">
                 <input
                   type="checkbox"
                   checked={isMenuChecked(parentMenu.parentId, childMenu.childId)}
                   disabled={!isParentChecked(parentMenu.parentId)}
                   onChange={() =>
                     handleMenuCheckboxChange(parentMenu.parentId, childMenu.childId)
                   }
                 />
                 {childMenu.childMenuName}
               </label>
               <div className="priviledgemenu">
                 <label className="child-menus-checkbox">
                   <input
                     type="checkbox"
                     checked={
                       checkedState[
                         `${parentMenu.parentId}-${childMenu.childId}-add`
                       ]
                     }
                     disabled={
                       !isMenuChecked(parentMenu.parentId, childMenu.childId)
                     }
                     onChange={() =>
                       handleCheckboxChange(
                         parentMenu.parentId,
                         childMenu.childId,
                         "add"
                       )
                     }
                   />
                   Add
                 </label>
                 <label className="child-menus-checkbox">
                   <input
                     type="checkbox"
                     checked={
                       checkedState[
                         `${parentMenu.parentId}-${childMenu.childId}-edit`
                       ]
                     }
                     disabled={
                       !isMenuChecked(parentMenu.parentId, childMenu.childId)
                     }
                     onChange={() =>
                       handleCheckboxChange(
                         parentMenu.parentId,
                         childMenu.childId,
                         "edit"
                       )
                     }
                   />
                   Edit
                 </label>
                 <label className="child-menus-checkbox">
                   <input
                     type="checkbox"
                     checked={
                       checkedState[
                         `${parentMenu.parentId}-${childMenu.childId}-view`
                       ]
                     }
                     disabled={
                       !isMenuChecked(parentMenu.parentId, childMenu.childId)
                     }
                     onChange={() =>
                       handleCheckboxChange(
                         parentMenu.parentId,
                         childMenu.childId,
                         "view"
                       )
                     }
                   />
                   View
                 </label>
               </div>
             </div>
             {childMenu.subchildren && (
               <div className="subchild-menus">
                 {childMenu.subchildren.map((subchildMenu) => (
                   <div key={subchildMenu.subchildId} className="child-item">
                     <label className="child-title">
                       <input
                         type="checkbox"
                         disabled={
                          !isMenuChecked(parentMenu.parentId, childMenu.childId)
                        }
                         checked={
                           checkedState[
                             `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-menu`
                           ]
                         }
                         onChange={() =>
                           handleCheckboxChange(
                             parentMenu.parentId,
                             childMenu.childId,
                             `${subchildMenu.subchildId}-menu`
                           )
                         }
                       />
                       {subchildMenu.subchildMenuName}
                     </label>
                     <div className="child-actions">
                       <label className="child-menus-checkbox">
                         <input
                           type="checkbox"
                           checked={
                             checkedState[
                               `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-add`
                             ]
                           }
                           disabled={
                             !checkedState[
                               `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-menu`
                             ]
                           }
                           onChange={() =>
                             handleCheckboxChange(
                               parentMenu.parentId,
                               childMenu.childId,
                               `${subchildMenu.subchildId}-add`
                             )
                           }
                         />
                         Add
                       </label>
                       <label className="child-menus-checkbox">
                         <input
                           type="checkbox"
                           checked={
                             checkedState[
                               `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-edit`
                             ]
                           }
                           disabled={
                             !checkedState[
                               `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-menu`
                             ]
                           }
                           onChange={() =>
                             handleCheckboxChange(
                               parentMenu.parentId,
                               childMenu.childId,
                               `${subchildMenu.subchildId}-edit`
                             )
                           }
                         />
                         Edit
                       </label>
                       <label className="child-menus-checkbox">
                         <input
                           type="checkbox"
                           checked={
                             checkedState[
                               `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-view`
                             ]
                           }
                           disabled={
                             !checkedState[
                               `${parentMenu.parentId}-${childMenu.childId}-${subchildMenu.subchildId}-menu`
                             ]
                           }
                           onChange={() =>
                             handleCheckboxChange(
                               parentMenu.parentId,
                               childMenu.childId,
                               `${subchildMenu.subchildId}-view`
                             )
                           }
                         />
                         View
                       </label>
                     </div>
                   </div>
                 ))}
               </div>
             )}
           </div>
         ))}
       </div>
     )}
   </div>
   
     
      ))}
      <div className="pre-submit-btn-container">
        <button className="pre-submit-btn" onClick={handleSubmit}>Submit</button>
      </div>
    </div>
  );
};

PrivilegesComponent.propTypes = {
  privilegesData: PropTypes.array.isRequired,
};

export default PrivilegesComponent;
